(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('transaction-charges-settings', {
            parent: 'entity',
            url: '/transaction-charges-settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.transactionChargesSettings.title" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/transaction-charges-settings/transaction-charges-settings.html',
                    controller: 'TransactionChargesSettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('transactionChargesSettings');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('transaction-charges-settings-new', {
            parent: 'transaction-charges-settings',
            url: '/new',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transaction-charges-settings/transaction-charges-settings-dialog.html',
                    controller: 'TransactionChargesSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            	 id:null,  
                            	name:null                            	
                             
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('transaction-charges-settings', null, { reload: 'transaction-charges-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('transaction-charges-settings-edit', {
            parent: 'transaction-charges-settings',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transaction-charges-settings/transaction-charges-settings-dialog.html',
                    controller: 'TransactionChargesSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['TransactionChargesSettings', 'GlobalValues', function(TransactionChargesSettings, GlobalValues) {
                                     return TransactionChargesSettings.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('transaction-charges-settings-delete', {
            parent: 'transaction-charges-settings',
            url: '/delete/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transaction-charges-settings/transaction-charges-settings-delete-dialog.html',
                    controller: 'TransactionChargesSettingsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TransactionChargesSettings', 'GlobalValues', function(TransactionChargesSettings, GlobalValues) {
                            return TransactionChargesSettings.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    //$state.go('^', null, { reload: true });
                	$state.go('transaction-charges-settings', null, { reload: 'transaction-charges-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
         .state('transaction-charges-settings-todolist', {
            parent: 'dashboard',
            url: '/transactionChargesSettingsToDo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transaction-charges-settings/transaction-charges-settings-dialog.html',
                    controller: 'TransactionChargesSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('transaction-charges-settings', null, { reload: 'transaction-charges-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         .state('transaction-charges-settings-todolist-resubmit', {
            parent: 'dashboard',
            url: '/transactionChargesSettingsResubmit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transaction-charges-settings/transaction-charges-settings-dialog.html',
                    controller: 'TransactionChargesSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('transaction-charges-settings', null, { reload: 'transaction-charges-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        
        .state('transaction-charges-settings-auditLog', {
            parent: 'audit-log',
            url: '/transactionChargesSettingsAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transaction-charges-settings/transaction-charges-settings-dialog.html',
                    controller: 'TransactionChargesSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('transaction-charges-settings', null, { reload: 'transaction-charges-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
          .state('transaction-charges-settings-historyReport', {
            parent: 'history-report',
            url: '/transactionChargesSettingsAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transaction-charges-settings/transaction-charges-settings-dialog.html',
                    controller: 'TransactionChargesSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('transaction-charges-settings', null, { reload: 'transaction-charges-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
        
        
         };
    })();
